import { FlowLookbackDurationUnit, FlowProducedType } from 'flow-schema';

import { api } from 'common';

import { DocumentExtractFormFields } from './FormFields';
import { documentExtractDocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { type BlockConfigProps } from '../../types';

export const documentExtractConfig: BlockConfigProps<api.FlowDefinition.DocumentExtractBlockConfig> =
  {
    nodeHandles: [{ type: 'target' }, { type: 'source' }],
    defaultLabelPrefix: 'documentExtract',
    defaultConfig: {
      patient: {
        sourceBlockName: '',
        consumesType: FlowProducedType.Patient,
      },
      titleFilters: [],
      typeFilters: [],
      documentLimit: 10,
      lookbackDuration: {
        value: 10,
        unit: FlowLookbackDurationUnit.Years,
      },
      encounterId: undefined,
    },
    configFields: {
      getLanguageFieldValues: (config) => {
        return {
          [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.encounterId],
        };
      },
      schema: api.FlowDefinition.DocumentExtractBlockConfigSchema,
      FormFields: DocumentExtractFormFields,
    },
    documentationMarkdown: documentExtractDocumentationMarkdown,
  };
